import React from 'react'
import styled from 'styled-components'
import {Button as GrommetButton} from 'grommet/components/Button'

const StyledButton = styled(GrommetButton)`
  background-color: #3395fe;
  color: white;
  border-color: #3395fe;
  outline: none;
`

const Button = props => <StyledButton plain {...props} />

export default Button
